import config from '@/common/config';

const {
    VUE_APP_AMP_APP_ID: app,
    VUE_APP_AMP_JOB_ID: version,
    VUE_APP_APPLICATION_TITLE: appName,
} = config;

/* eslint-disable */
try {
    // try fancy version display in console
    console.log(`%c ${appName} %c ${app} — ${version} %c`, 'background:#0044D4 ; padding: 1px; border-radius: 3px 0 0 3px;  color: #fff; border:1px solid #0044D4;', 'background:#ffffff ; padding: 1px; border:1px solid #0044D4; border-radius: 0 3px 3px 0;  color: #0044D4', 'background:transparent');
} catch (error) {
    try {
        // if colored display fails try the basic version
        console.log(`${appName}: ${app} — ${version}`);
    } catch (subErr) {
        // otherwise give up, it's an old or strange browser
    }
}
